import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
      meta: { guest: true }
    },
    {
      path: '/',
      component: () => import('@/components/layout/MainLayout.vue'),
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'inbox',
          component: () => import('@/views/InboxView.vue')
        },
        {
          path: 'mailbox/:id',
          name: 'mailbox',
          component: () => import('@/views/InboxView.vue')
        },
        {
          path: 'mailbox/:id/calendar',
          name: 'calendar',
          component: () => import('@/views/CalendarView.vue')
        },
        {
          path: 'mailbox/:id/contacts',
          name: 'contacts',
          component: () => import('@/views/ContactsView.vue')
        },
        {
          path: 'mailbox/:id/tasks',
          name: 'tasks',
          component: () => import('@/views/TasksView.vue')
        },
        {
          path: 'settings',
          name: 'settings',
          component: () => import('@/views/MailboxSettingsView.vue')
        },
        {
          path: 'profile',
          name: 'profile',
          component: () => import('@/views/ProfileSettingsView.vue')
        },
        {
          path: 'admin/users',
          name: 'admin-users',
          component: () => import('@/views/AdminUsersView.vue'),
          meta: { requiresAdmin: true }
        }
      ]
    }
  ]
})

router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore()

  if (!authStore.isAuthenticated && authStore.token) {
    await authStore.checkAuth()
  }

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next({ name: 'login' })
  } else if (to.meta.guest && authStore.isAuthenticated) {
    next({ name: 'inbox' })
  } else if (to.meta.requiresAdmin && !authStore.user?.admin) {
    next({ name: 'inbox' })
  } else {
    next()
  }
})

export default router
